import React from "react";
import media from "../../data/Media.json";
import cdrom from "../../data/CdRom.json";
import "../../styles/MediaAndCD-ROMs.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const MediaAndCD = () => {
  const [mediaData, setMedia] = useState({ media: [] });
  const [cdromsData, setCdroms] = useState({ cdRoms: [] });
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      setMedia(media);
      setCdroms(cdrom);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (!mediaData || !cdromsData) return <p>Loading...</p>;

  return (
    <div className="articles-list">
      <h2>Media</h2>
      <div className="articles">
        <ol className="articles-list">
          {mediaData.media.map((entry, index) => (
            <li key={index}>
              <span>{entry.title}</span>
              {entry.link && (
                <>
                  {" "}
                  <Link
                    to={entry.link}
                    style={{ textDecoration: "none", color: "darkblue" }}
                  >
                    {entry.link}
                  </Link>
                </>
              )}
            </li>
          ))}
        </ol>
      </div>
      <h2>CD ROMs</h2>
      <div className="articles">
        <ol>
          {cdromsData.cdRoms.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default MediaAndCD;
